/**
 * Member List Animation
 * Staggers appearance of team member items on scroll
 */

export function initMemberListAnimation() {
  const memberContainer = document.querySelector('.member_list');
  const memberItems = gsap.utils.toArray('.member_item');
  
  if (memberContainer && memberItems.length) {
    gsap.from(memberItems, {
      scrollTrigger: {
        trigger: memberContainer,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.2
    });
  }
}
